import { Col, Row, Skeleton } from 'antd';
import React from 'react';

import FinancialChart from '@/components/Dashboard/Mock/MockCharts/FinancialChart/FinancialChart';
import PayOverdue from './PayOverdue';
import PayToday from './PayToday';
import ReceivableOverdue from './ReceivableOverdue';
import ReceiveToday from './ReceiveToday';
import ForecastCalcReceivableAndPayable from './ForecastCalcReceivableAndPayable';
import { DashboardType } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import HomeInformatives from '../Mock/HomeInformatives';
import ReceivablePayDayValue from './ReceivablePayDayValue';
import ReceivablePayDayQuantity from './ReceivablePayDayQuantity';
import PayablePayDayValue from './PayablePayDayValue';
import PayablePayDayQuantity from './PayablePayDayQuantity';
import { useDashboardData } from '@/core/domain/workorder/Dashboard/Dashboard.hooks';

const DashboardFinancialView: React.FC = () => {
  const { data, isLoading } = useDashboardData({
    dashboardType: DashboardType.financial,
  });

  return (
    <Skeleton active loading={isLoading} paragraph={{ rows: 10 }}>
      <Row gutter={[16, 16]}>
        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <ReceiveToday value={data?.receivableDayValue} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <ReceivableOverdue value={data?.receivableExpiredQuantity} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <PayToday value={data?.payableDayValue} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <PayOverdue value={data?.payableExpiredQuantity} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <ReceivablePayDayValue value={data?.receivableSettledDayValue || 0} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <ReceivablePayDayQuantity
            value={data?.receivableSettledDayQuantity}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <PayablePayDayValue value={data?.payableSettledDayValue} />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <PayablePayDayQuantity value={data?.payableSettledDayQuantity} />
        </Col>

        <Col span={24} xl={12} xxl={8}>
          <FinancialChart />
        </Col>

        <Col span={24} xl={12} xxl={8}>
          <ForecastCalcReceivableAndPayable dashboardData={data} />
        </Col>

        <Col span={24} xl={24} xxl={8}>
          <HomeInformatives />
        </Col>
      </Row>
    </Skeleton>
  );
};

export default DashboardFinancialView;
